export const apiUrl = process.env.REACT_APP_API_URL
